import React from 'react';

import classnames from 'classnames';
import { InputAdornment, styled } from '@mui/material';
import MuiTextField, {
  TextFieldProps as MuiTextFieldProps,
} from '@mui/material/TextField';

export type InputProps = MuiTextFieldProps & {
  startAdornment?: React.ReactNode;
  readOnly?: boolean;
  warning?: boolean;
};

const StyledInput = styled(
  ({ className, warning, readOnly, ...textFieldProps }: InputProps) => (
    <MuiTextField
      fullWidth
      InputProps={{ readOnly }}
      className={classnames(
        { warning: warning && !textFieldProps.error },
        className
      )}
      {...textFieldProps}
    />
  )
)<InputProps>`
  &.warning .MuiOutlinedInput-notchedOutline {
    border-color: ${(props) => props.theme.palette.warning.main};
  }
`;

export default function Input({ startAdornment, ...props }: InputProps) {
  if (startAdornment) {
    props.InputProps = {
      ...props.InputProps,
      startAdornment: (
        <InputAdornment position='start'>{startAdornment}</InputAdornment>
      ),
    };
  }
  return <StyledInput {...props} />;
}
